module.exports = __webpack_public_path__ + "img/hotelFamily-6.3385e9a2.jpg";